import React from 'react';
import DescriptionIcon from '@material-ui/icons/Description';
import EuroIcon from '@material-ui/icons/EuroSymbol';
import PeopleIcon from '@material-ui/icons/People';
import TdbIcon from '@material-ui/icons/Dvr';
import Facture from './Facture';
import ClientList from './clientList/ClientList';
import Client from './client/Client';
import TableauDeBord from './TableauDeBord';
import Devis from './devis/Devis';
import DevisList from './devisList/DevisList';

var refClient = {};
var client = {};
client["label"] = 'client';
client["path"] = '/clients/client';
client["pathvar"] = '/:numero';
client["component"] = <Client ref={(instance) => { refClient.ref = instance }} />;
client["instance"] = refClient;
client["showBottomNavigation"] = true;
client["exact"] = false;

var refDevis = {};
var devis = {};
devis["label"] = 'devis';
devis["path"] = '/devis/devisedition';
devis["pathvar"] = '/:numero';
devis["component"] = <Devis ref={(instance) => { refDevis.ref = instance }} />;
devis["instance"] = refDevis;
devis["showBottomNavigation"] = true;
devis["exact"] = false;

var menuData = {
    "tdb": {
        label: 'Tableau de bord',
        path: '/',
        icon: <TdbIcon />,
        component: <TableauDeBord />,
        menu: true,
        exact: true,
    }
    ,

    "clientsList": {
        label: 'Clients',
        path: '/clients',
        icon: <PeopleIcon />,
        component: <ClientList />,
        menu: true,
        exact: true,
    }
    ,

    "devisList": {
        label: 'Devis',
        path: '/devis',
        icon: <DescriptionIcon />,
        component: <DevisList />,
        menu: true,
        exact: true,
    }
    ,

    "facturesList": {
        label: 'Factures',
        path: '/factures',
        icon: <EuroIcon />,
        component: <Facture />,
        menu: false,
        exact: true,
    }
};

menuData["clientEdit"] = client;
menuData["devisEdit"] = devis;

export default menuData;


// WEBPACK FOOTER //
// ./src/components/content/MenuDatas.js